import React from "react";
import ReactDOM from "react-dom";

class Option extends React.Component {
  componentDidMount() {
    const node = ReactDOM.findDOMNode(this);

    if (
      parseInt(this.props.option.selected, 10) ===
      parseInt(this.props.option.value, 10)
    ) {
      setTimeout(function () {
        node.scrollIntoView(true);
      }, 50);
    }
  }

  render() {
    const selected =
      parseInt(this.props.option.selected, 10) ===
      parseInt(this.props.option.value, 10)
        ? "selected"
        : "";

    const handleClick = (event) => {
      if (this.props.option.type === "font") {
        this.props.onSelect(this.props.option, event);
      } else {
        event.preventDefault();
      }
    };

    return (
      <div
        className={`select-typeface__option select-typeface__option--${this.props.option.type} select-typeface__option--${this.props.option.id}`}
        onClick={handleClick}
      >
        {this.props.option.type === "category" && (
          <div className="optiongroup__label">
            <span>{this.props.option.name}</span>
          </div>
        )}

        {this.props.option.type === "font" && (
          <div className={`typeface__thumbnail ${selected}`}>
            <img
              src={this.props.option.thumbnail}
              alt={this.props.option.name}
            />

            <div className="typeface__name">{this.props.option.name}</div>
          </div>
        )}
      </div>
    );
  }
}

export default Option;
